module.exports = __webpack_public_path__ + "img/iconHelp.c19a563b.svg";